<template>
    <b-modal
        v-model="logisticServiceModal"
        size="md"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">Costo Servicio logístico</div>
        </template>
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">
                    El costo del flete para este servicio logístico es de <strong>$ {{ numberFormat(costoFlete)}} </strong> <small>IVA Incluído</small>, está seguro que desea realizar el pedido?
                </p>
            </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
            </b-button>
            <b-button variant="success" @click.prevent="$emit('confirm-pedido', itemsProveedor, pedidoData)">
                Confirmar
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "LogisticServicePriceModal",
    props: {
        logisticServiceModal: {
            type: Boolean
        },
        costoFlete: {
            type: Number
        },
        itemsProveedor: {
            type: Array
        },
        pedidoData: {
            type: Object
        },
    }
};

</script>
<style scoped>

</style>